import { Component, OnInit } from '@angular/core';
import { StorageService } from './services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { VersionCheckService } from './services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private translateService: TranslateService,
    private storageService: StorageService,
    private versionCheckService: VersionCheckService
  ) {}

  ngOnInit() {
    this.storageService.init();
    const storedLang = localStorage.getItem('language');
    if (storedLang) {
      this.translateService.use(storedLang);
    } else {
      const defaultLang = 'en';
      this.translateService.use(defaultLang);
      localStorage.setItem('language', defaultLang);
    }

    // Check for app updates
    this.versionCheckService.checkForUpdates();
  }
}
